Object.defineProperty(module.exports, "__esModule", {
  value: true
})

module.exports.default = function(tokens) {
  return {
    breadcrumbForegroundColorDefault: tokens.themeActionPrimaryDefault,
    breadcrumbForegroundColorHover: tokens.themeActionPrimaryHover,
    breadcrumbForegroundColorPressed: tokens.themeActionPrimaryPressed,
    breadcrumbForegroundColorSelected: tokens.themeInkDefault,
    breadcrumbSeparatorColor: tokens.themeBorderDefault,
    breadcrumbSpacingHorizontal: 24,
    breadcrumbFontSize: 14,
    breadcrumbLineHeight: "20px",
    breadcrumbMotionDuration: "100ms",
    breadcrumbMotionFunction: "ease"
  }
};